import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';



import {
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';
import { Subject, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView
} from 'angular-calendar';
import { UIService } from '../../shared/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalPubSub } from '../../shared/global-sub-pub.service';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  loginFormGroup: FormGroup;
  isLoading = false;
  hide = true;
  hide2 = true;
  isWKWebView = false;
  showWrongEmailPasswordMessage = false;
  private loadingSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private modal: NgbModal,
    private uiService: UIService,
    private _ref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private globalPubSub: GlobalPubSub
  ) { }

  ngOnInit() {
    this.loginFormGroup = this.formBuilder.group({
      'email' : [null, Validators.required],
      'password' : [null, Validators.required]
    });
    this.loginFormGroup.valueChanges.subscribe(val => {
    });
    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      this.showWrongEmailPasswordMessage = true;
      this._ref.markForCheck();
    });

    //this.sampleEventName2 = this.sampleEventName2.bind(this);
    //this.globalPubSub.subscribe('sampleEventName2', this.sampleEventName2);

  }

  sampleEventName2(argument) {
    this.isWKWebView = argument;
  }

  onSubmitLogin() {
    /*
    const authData = {
      email: "tagnikzur01@vfi.io",
      password: "12345"
    };
    */
    const authData = {
      email: this.loginFormGroup.value.email,
      password: this.loginFormGroup.value.password
    };

    //this.globalPubSub.fireEvent('sampleEventName', 'test');

    this.authService.login(authData);

    /*this.authService.login(form.value.email, form.value.password).subscribe(data => {
      console.log(data);
    })*/

  }

  onLoginNew(show) {
    /*this.uiService.loadingStateChanged.next(show);
    /*
    const authData = {
      email: form.value.email,
      password: form.value.password
    }*/
    this.authService.loginNew(show);
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    console.log(language);

  }

  getLanguage() {
    return this.translate.currentLang;
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }
  /*
  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter(iEvent => iEvent !== event);
        this.handleEvent('Deleted', event);
      }
    }
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [
    {
      start: subDays(startOfDay(new Date()), 1),
      end: addDays(new Date(), 1),
      title: 'A 3 day event',
      color: colors.red,
      actions: this.actions,
      allDay: true,
      resizable: {
        beforeStart: true,
        afterEnd: true
      },
      draggable: true
    },
    {
      start: startOfDay(new Date()),
      title: 'An event with no end date',
      color: colors.yellow,
      actions: this.actions
    },
    {
      start: subDays(endOfMonth(new Date()), 3),
      end: addDays(endOfMonth(new Date()), 3),
      title: 'A long event that spans 2 months',
      color: colors.blue,
      allDay: true
    },
    {
      start: addHours(startOfDay(new Date()), 2),
      end: new Date(),
      title: 'A draggable and resizable event',
      color: colors.yellow,
      actions: this.actions,
      resizable: {
        beforeStart: true,
        afterEnd: true
      },
      draggable: true
    }
  ];

  activeDayIsOpen: boolean = true;


  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map(iEvent => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true
        }
      }
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter(event => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
  */


}
export {};

declare global {
  interface Window {
    webkit?: any;
  }
}

